module.exports = __webpack_public_path__ + "media/assets/images/nosco/kitchen-e7ba081df14e5c3776da2ef6d6b0f209.png";